import { CustomerType } from '../../../interfaces/common/customer';
import { ILocation, LocationEffect } from '../../../interfaces/common/location';
import {
  BranchEffect,
  BranchType,
} from '../../../interfaces/delivery-company/branches';
import {
  CompactMerchantType,
  MerchantEffect,
  MerchantType,
} from '../../../interfaces/delivery-company/merchants';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { ShopLocationEffect, ShopLocationType } from '../../../interfaces/delivery-company/pickups';
import { CustomerEffect } from '../create-customer-form/create-customer-form';

export interface assignCustomerProviderProps {
  orderData?: OrderType;
  setOrderData: React.Dispatch<React.SetStateAction<OrderType | undefined>>;
}

export const assignCustomerProvider = ({
  orderData,
  setOrderData,
}: assignCustomerProviderProps): CustomerEffect => {
  return (value: CustomerType) => {
    if (!orderData) return;

    const newOrderData: OrderType = {
      ...orderData,
      customer: value,
    };

    if (value && value.locations.length > 0) {
      newOrderData.customer_location = value.locations[0];
    } else {
      newOrderData.customer_location = null
    }

    setOrderData(newOrderData);
  };
};

export interface assignMerchantProviderProps {
  orderData?: OrderType;
  setOrderData: React.Dispatch<React.SetStateAction<OrderType | undefined>>;
}

export const assignMerchantProvider = ({
  orderData,
  setOrderData,
}: assignMerchantProviderProps): MerchantEffect => {
  return (value: MerchantType) => {
    if (!orderData) return;
    const compactMerchant: CompactMerchantType = {
      id: value.id,
      name: value.name,
      phone_number: value.phone_number,
      has_usable_password: value.has_usable_password,
      default_delivery_fee: value.default_delivery_fee,
      default_return_fee: value.default_return_fee,
      address: value.address,
      shop_locations: value.shop_locations,
      is_active: value.is_active
    };
    setOrderData({
      ...orderData,
      merchant: compactMerchant as MerchantType,
    });
  };
};

export interface assignMerchantProviderProps {
  orderData?: OrderType;
  setOrderData: React.Dispatch<React.SetStateAction<OrderType | undefined>>;
}

export const assignBranchProvider = ({
  orderData,
  setOrderData,
}: assignMerchantProviderProps): BranchEffect => {
  return (value: BranchType) => {
    if (!orderData) return;
    setOrderData({ ...orderData, branch: value });
  };
};



export const assignPickupLocationProvider = ({
  orderData,
  setOrderData,
}: assignMerchantProviderProps): ShopLocationEffect => {
  return (value: ShopLocationType) => {
    if (!orderData) return;
    setOrderData({ ...orderData, merchant_location: value });
  };
};


export const assignLocationProvider = ({
  orderData,
  setOrderData,
}: assignMerchantProviderProps): LocationEffect => {
  return (value: ILocation) => {
    if (!orderData) return;
    setOrderData({ ...orderData, customer_location: value });
  };
};
